module.exports = __webpack_public_path__ + "media/images/mypage/icon/white/ico_angle_right-117cdaf9b384f9e3979051b9bab4a7cf.svg";